import { Injectable } from '@angular/core';
import { AnalyticsEventArgs, AnalyticsEvents } from './analytics-events';

/**
 * Sends custom analytics events from the `AnalyticsEvents` catalog. Libraries inject this because
 * they can't import the app; advisor-ui provides it with its `PostHogService`. Without a provider
 * (unit tests, other apps) the default does nothing.
 */
@Injectable({ providedIn: 'root', useFactory: () => new NoopAnalyticsTracker() })
export abstract class AnalyticsTracker {
    abstract track<K extends keyof AnalyticsEvents>(
        name: K,
        ...properties: AnalyticsEventArgs<K>
    ): void;
}

class NoopAnalyticsTracker extends AnalyticsTracker {
    track(): void {
        // No analytics provider: drop the event.
    }
}
